<template>
    <div
        class="dt-loading-indicator"
        :style="{ 
            width: size + 'px', 
            height: size + 'px',
            animationDuration: duration + 's'
        }"
    ></div>
</template>

<script>
export default {
    name: "LoadingIndicator",
    props: {
        size: {
            type: Number,
            default: 24,
        },
        color: {
            type: String,
            default: "#2b2b2b",
        },
        strokeWidth: {
            type: Number,
            default: 2,
        },
        duration: {
            type: Number,
            default: 1,
        },
    },
};
</script>

<style lang="scss" scoped>
.dt-loading-indicator {
    border: 2px solid v-bind(color);
    border-bottom: 2px solid transparent;
    border-radius: 50%;
    animation: spin linear infinite;
    display: inline-block;
}

@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}
</style>
